// extracted by mini-css-extract-plugin
export var authorInfo = "CustomersSection-module--authorInfo--ea808";
export var authorName = "CustomersSection-module--authorName--63b99";
export var authorPosition = "CustomersSection-module--authorPosition--0f2de";
export var backgroundImage = "CustomersSection-module--backgroundImage--e2dce";
export var companyName = "CustomersSection-module--companyName--79ec4";
export var content = "CustomersSection-module--content--d59f0";
export var contentGroup = "CustomersSection-module--contentGroup--5a47e";
export var customersCard = "CustomersSection-module--customersCard--8fe88";
export var innerWrapper = "CustomersSection-module--innerWrapper--33c53";
export var wrapper = "CustomersSection-module--wrapper--72038";